import React, { memo, useEffect, useState } from 'react';

import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';

import * as S from './style';

interface IProps {
  /** className */
  className?: string;
  /** h1, h2, h3, h4, h5 */
  level?: number;
  /** children */
  children?: React.ReactNode;
  /** 맨 끝에 붙는 컨텐츠 */
  suffix?: React.ReactNode;
}

const Title = ({ className = '', level = 1, children, suffix }: IProps) => {
  const [h, setH] = useState<string>('h1');

  useEffect(() => {
    setH(`h${level}`);
  }, [level]);

  const param = {
    className: classNameBind(['title', className]),
  };

  return (
    <S.Title as={h} {...param}>
      {children}
      {suffix && <S.Suffix>{suffix}</S.Suffix>}
    </S.Title>
  );
};

export default memo(Title);
